export default {
	//触发事件方法名在eventActionMap.js中，它对应eventActionHandlerMap.js中方法，
	//其中“pipeline-toggle”为eventActionMap.js中触发事件value值，对应的toggleFlow方法在pipelineComponent.vue组件中。
	"pipeline-toggle": (args, targetJson, targetElement, bindJson) => {
		console.log("pipeline-toggle", bindJson)
		targetElement.toggleFlow()
	},
	"pipeline-stop": (args, targetJson, targetElement, bindJson) => {
		console.log("pipeline-stop", bindJson)
		targetElement.stopFlow()
	},
	"pipeline-start": (args, targetJson, targetElement, bindJson) => {
		console.log("pipeline-start", bindJson)
		targetElement.startFlow()
	},
	"pipeline-disappear": (args, targetJson, targetElement) => {
		targetElement.disappearPipeline()
	},
	"pipeline-appear": (args, targetJson, targetElement) => {
		targetElement.disappearPipeline()
	},
	"rectangle-disappear": (args, targetJson, targetElement) => {
		targetElement.disappearRectangle()
	},
	"rectangle-appear": (args, targetJson, targetElement) => {
		targetElement.appearRectangle()
	},
	"rectangle-flash": (args, targetJson, targetElement) => {
		targetElement.flashRectangle()
	},
	"rectangle-stopFlash": (args, targetJson, targetElement) => {
		targetElement.stopFlashRectangle()
	},
	"circle-disappear": (args, targetJson, targetElement) => {
		targetElement.disappearCircle()
	},
	"circle-appear": (args, targetJson, targetElement) => {
		targetElement.appearCircle()
	},
	"circle-flash": (args, targetJson, targetElement) => {
		targetElement.flashCircle()
	},
	"circle-stopFlash": (args, targetJson, targetElement) => {
		targetElement.stopFlashCircle()
	},
	"arrow-disappear": (args, targetJson, targetElement) => {
		targetElement.disappearArrow()
	},
	"arrow-appear": (args, targetJson, targetElement) => {
		targetElement.appearArrow()
	},
	"arrow-flash": (args, targetJson, targetElement) => {
		targetElement.flashArrow()
	},
	"arrow-stopFlash": (args, targetJson, targetElement) => {
		targetElement.stopFlashArrow()
	},
	"triangle-disappear": (args, targetJson, targetElement) => {
		targetElement.disappearTriangle()
	},
	"triangle-appear": (args, targetJson, targetElement) => {
		targetElement.appearTriangle()
	},
	"triangle-flash": (args, targetJson, targetElement) => {
		targetElement.flashTriangle()
	},
	"triangle-stopFlash": (args, targetJson, targetElement) => {
		targetElement.stopFlashTriangle()
	},
	"wheel-disappear": (args, targetJson, targetElement) => {
		targetElement.disappearWheel()
	},
	"wheel-appear": (args, targetJson, targetElement) => {
		targetElement.appearWheel()
	},
	"wheel-clockWise": (args, targetJson, targetElement) => {
		targetElement.clockWiseWheel()
	},
	"wheel-stop": (args, targetJson, targetElement) => {
		targetElement.stopWheel()
	},
	"staticLabel-disappear": (args, targetJson, targetElement) => {
		targetElement.disappearStaticLabel()
	},
	"staticLabel-appear": (args, targetJson, targetElement) => {
		targetElement.appearStaticLabel()
	},
	"dynamicLabel-disappear": (args, targetJson, targetElement) => {
		targetElement.disappearDynamicLabel()
	},
	"dynamicLabel-appear": (args, targetJson, targetElement) => {
		targetElement.appearDynamicabel()
	},
	"img-disappear": (args, targetJson, targetElement) => {
		targetElement.disappearImg()
	},
	"img-appear": (args, targetJson, targetElement) => {
		targetElement.appearImg()
	},
	"variable-update": (args, varItem, value, targetElement) => {  // 变量绑定事件
		targetElement.variableUpdate(varItem, value)  // create.vue
	}
	// "page-change"
}